import { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export function Description({
  children,
  className,
}: { children: string } & HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={twMerge("font-normal", className)}
      style={{
        color: "rgb(156, 163, 175)",
        fontSize: "14px",
      }}
    >
      {children}
    </div>
  );
}
